import type { RangeAvailabilityCalendarLegendLabels } from './types';

import { memo } from 'react';

import { Box, Typography } from '@mui/material';

import {
  getRangeAvailabilityLegendLabelSx,
  getRangeAvailabilityLegendSx,
} from './range-availability-calendar-styles';

interface LegendPillProps {
  label: string;
  color: 'info' | 'primary' | 'error';
}

const LegendPill = memo(({ label, color }: LegendPillProps) => (
  <Box
    sx={[
      {
        display: 'inline-flex',
        alignItems: 'center',
        px: 1,
        minHeight: 36,
        borderRadius: 0.5,
      },
      (theme) => getRangeAvailabilityLegendSx(theme, color),
    ]}
  >
    <Typography variant="body2" sx={(theme) => getRangeAvailabilityLegendLabelSx(theme, color)}>
      {label}
    </Typography>
  </Box>
));

LegendPill.displayName = 'LegendPill';

interface RangeAvailabilityCalendarLegendProps {
  labels: RangeAvailabilityCalendarLegendLabels;
}

export const RangeAvailabilityCalendarLegend = memo(
  ({ labels }: RangeAvailabilityCalendarLegendProps) => (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 0.5,
        py: 1,
        px: 3.5,
        width: '100%',
      }}
    >
      <LegendPill label={labels.window} color="info" />
      {labels.preferred ? <LegendPill label={labels.preferred} color="primary" /> : null}
      {labels.excluded ? <LegendPill label={labels.excluded} color="error" /> : null}
    </Box>
  )
);

RangeAvailabilityCalendarLegend.displayName = 'RangeAvailabilityCalendarLegend';
